import { OnboardingStages, OnboardingForms } from '../../constants';

export const onboardingHelpers = {
  getOnboardingStep
}

// function getOnboardingStep(onboardingStep) {
//   console.log('*******');
//   console.log(onboardingStep);
//   switch(onboardingStep) {
//     case OnboardingStages.PAN_NOT_VERIFIED:
//       return OnboardingForms.KYC_CHECK;

//     case OnboardingStages.PAN_VERIFIED:
//     case OnboardingStages.DOCS_NOT_UPLOADED:
//       return OnboardingForms.KYC_READY;

//     case OnboardingStages.DOCS_UPLOADED:
//     case OnboardingStages.ONBOARDING_COMPLETE:
//       return OnboardingForms.SETUP_COMPLETED;
      
//     default:
//       return 0;
//   }
// }

function getOnboardingStep(onboardingStage) {
  switch(onboardingStage) {
    case OnboardingStages.DOCS_UPLOADED: 
    case OnboardingStages.ONBOARDING_COMPLETE:
      return OnboardingForms.SETUP_COMPLETED;

    case OnboardingStages.PAN_VERIFIED:
      return OnboardingForms.KYC_INCOMPLETE;

    case OnboardingStages.PAN_NOT_VERIFIED: 
      return OnboardingForms.KYC_CHECK;

    case OnboardingStages.DOCS_NOT_UPLOADED: 
    case OnboardingStages.CAN_FORM_COMPLETED: 
      return OnboardingForms.UPDATE_DOCS;

    default:
      return OnboardingForms.KYC_CHECK;
  }
}